import render from './render'

export default {
  name: 'Processor',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
